import React, { FC, useMemo } from "react"
import "./gradient.scss"

type IGradientRankingProps = {
  data: { value: number; name: string }[]
  color?: string
  highLightType?: string
}

const GradientRanking: FC<IGradientRankingProps> = ({
  data,
  highLightType = "red",
  color='linear-gradient(90deg,rgba(75, 86, 115, 1) 0%,rgba(192, 50, 253, 1) 100%)'
}) => {
  let l = useMemo(() => {
    if (!data.length) {
      return []
    }
    let max = data[0] ? data[0].value : 1
    let newList = data.map((el) => {
      return {
        ...el,
        radio: Math.round((el.value / max) * 10000) / 100 || 0,
      }
    })
    return newList
  }, [data])
  return (
    <div className="ct-bar-gradient">
      <div className="rank-list">
        {l.map((el, index) => {
          return (
            <div
              key={index}
              className={
                "rank-item" + (index < 1 ? " active_" + highLightType : "")
              }
            >
              <div className="item-name">
                <span className="name">{el.name}</span>
                <span>{`TOP${index + 1}`}</span>
              </div>
              <div className="item-radio">
                <div
                  style={{ width: el.radio + "%", background: color }}
                  className="item-radio-block"
                ></div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default GradientRanking
